import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTabGroup } from '@angular/material/tabs';
import { ToastService } from 'angular-toastify';
import { NgxSpinnerService } from 'ngx-spinner';
import { JIRA_BOARD_PROJECT_Name } from 'src/app/constant/constant';
import { RepositoryService } from 'src/app/service/repository.service';

@Component({
  selector: 'app-azureotherissue',
  templateUrl: './azureotherissue.component.html',
  styleUrls: ['./azureotherissue.component.css']
})
export class AzureotherissueComponent implements OnInit {
  cloudForm: FormGroup;
  summary: string;
  projectName: string = JIRA_BOARD_PROJECT_Name.AZURE;
  @Input() tabGroup!: MatTabGroup;
  constructor(private fb: FormBuilder, private _toastService: ToastService, private spinner: NgxSpinnerService, private rs: RepositoryService) { }

  ngOnInit(): void {
    this.cloudForm = this.fb.group({
      description: ['', [Validators.required]]
    })
  }


  resetform(): void {
    this.cloudForm.reset();
  }

  onSubmit(): void {
    this.spinner.show();
    this.summary = `Azure Other issue Requested By ${sessionStorage.getItem("email")}`;
    this.rs.createCloudServiceRequest(this.projectName, this.summary, this.cloudForm.value, sessionStorage.getItem("wwid")
    ).subscribe({
      next: (res) => {
        this._toastService.success(res['message']);
        this.resetform();
        if (this.tabGroup) { this.tabGroup.selectedIndex = 1 };
        this.spinner.hide();

      },
      error: (error) => {
        this._toastService.error(error?.message || "An unexpected error occurred.");
        this.spinner.hide();

      }
    });
  }


}
